/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";
import { setSnackbar } from "../snackbarReducer";

const initialState = {
  gmailUnsync: false,
  googleAuthUrl: "",
  googleProfile: {},
  mlsOptions: [],
  validRoutingNumberOptions: [],
  user: null,
  loading: false,
  errors: {},
};

const disconnectGmail = createAsyncThunk("personal/disconnectGmail", (_, thunkApi) => {
  const {
    personal: { deleteGoogleAuthUrl },
  } = thunkApi.getState();
  return caseTransformingAxios
    .delete(`${deleteGoogleAuthUrl}.json`, { maxRedirects: 0 })
    .then((response) => response.data);
});

const updatePersonalAccount = createAsyncThunk("personal/updatePersonalAccount", (formData, thunkApi) => {
  const {
    personal: { user },
  } = thunkApi.getState();
  return caseTransformingAxios
    .patch(`/users/${user.id}.json`, formData)
    .then((response) => {
      thunkApi.dispatch(
        setSnackbar({
          text: "Updated successfully!",
          schema: "executed",
          show: true,
          timeout: 3000,
          closeOnTimeout: () => thunkApi.dispatch(setSnackbar({ show: false })),
        }),
      );
      return response.data;
    })
    .catch((error) => {
      thunkApi.dispatch(
        setSnackbar({
          text: "Something went wrong. Check the form for errors and try again.",
          schema: "error",
          show: true,
          actionLabel: "Dismiss",
          onActionButtonClick: () => thunkApi.dispatch(setSnackbar({ show: false })),
        }),
      );
      return thunkApi.rejectWithValue(error.response.data);
    });
});

const personalReducer = createSlice({
  initialState,
  name: "personal",
  reducers: {
    addMls(state) {
      state.user.usersMlsesAttributes = [...state.user.usersMlsesAttributes, { tmpId: Date.now() }];
    },
    removeMls(state, action) {
      if (action.payload.id) {
        state.user.usersMlsesAttributes = state.user.usersMlsesAttributes.map((mls) =>
          mls.id === action.payload.id ? { ...mls, _destroy: true } : mls,
        );
      } else {
        state.user.usersMlsesAttributes = state.user.usersMlsesAttributes.filter(
          (mls) => mls.tmpId !== action.payload.tmpId,
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(disconnectGmail.fulfilled, (state) => {
      state.gmailUnsync = false;
      state.googleProfile = {};
    });
    builder
      .addCase(updatePersonalAccount.pending, (state) => {
        state.errors = {};
        state.loading = true;
      })
      .addCase(updatePersonalAccount.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.loading = false;
      })
      .addCase(updatePersonalAccount.rejected, (state, action) => {
        state.loading = false;
        state.errors = action.payload?.errors || {};
      });
  },
});

export default personalReducer.reducer;
export const { addMls, removeMls } = personalReducer.actions;
export { disconnectGmail, updatePersonalAccount };
